import { Box, Grid } from '@mui/material'
import React from 'react'
import { Pages } from '../../constants'
import i18next from 'i18next'
import { useTheme } from '@mui/material/styles';
import { motion } from "framer-motion";
import Title from '../global/Title';
import { StyledLink } from './StyledLink'
import { CircleIcon } from './CircleIcon'
const Navigation = () => {
    let lng = i18next.language
    const theme = useTheme();
    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    }
    return (
        <Box sx={{ position: 'relative', zIndex: 2 }} component={motion.div}>
            <Title isHr={true} title={lng === 'en' ? 'Pages' : 'روابط مهمة'} color='primary.text' variant={'h6'} align='flex-start' sxTitle={{ mx: 1, fontSize: '32px', lineHeight: '100%', fontWeight: { md: 400, xs: 400 }, }} fontWeight={400} />
            {/* <Typography variant='h6' color={'primary.text'} mb={1} mt={2}>{lng === 'en' ? 'Pages' : 'الصفحات'}</Typography> */}
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                <Grid container>
                    {Pages?.map((page, i) => (
                        <Grid
                            item
                            component={motion.div}
                            xs={6}
                            md={6}
                            key={i}>
                            <StyledLink
                                to={page.path}
                                className={'linkFooter'}
                                component={motion.div}
                                style={({ isActive }) => ({
                                    color: isActive ? theme.palette.footer.link : theme.palette.footer.link,
                                    position: "relative"
                                })}
                                onClick={() => scrollToTop()}
                            >
                                <CircleIcon sx={{
                                    opacity: 0.8,
                                }} />
                                {lng === 'ar' ? page.name : page.name_en}
                            </StyledLink>
                        </Grid>
                    ))}
                    <Grid
                        item
                        xs={6}
                        md={12}>
                        <StyledLink
                            to={'privacy-policy'}
                            className={'linkFooter'}
                            style={({ isActive }) => ({
                                color: isActive ? theme.palette.footer.link : theme.palette.footer.link,
                            })}
                            onClick={() => scrollToTop()}
                        >
                            <CircleIcon sx={{
                                opacity: 0.8,
                            }} />
                            {lng === 'ar' ? 'سياسة الخصوصية' : 'privacy policy'}
                        </StyledLink>
                    </Grid>
                </Grid>
            </Box>
        </Box>
    )
}

export default Navigation